/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useState, useContext } from 'react'
import styled from '@emotion/styled'
import { Button, Popconfirm, Modal, Icon, Table } from 'antd'
import WSAccessEditPrompt from './WSAccessEditPrompt'
import WSAccessFileUpload from './WSAccessFileUpload'
import qs from 'query-string'
// import { Content, FullHeightSizer } from 'core/screen-util'
import FileDownload from './FileDownload'
import { ErrorContext } from 'context'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
import { getAuthorization, getCredentials } from 'api/pgads'
// const Container = styled.div`
//   display: flex;
//   align-items: center;
//   padding-top: 10px;
//   padding-bottom: 10px;
//   border-bottom: 1px solid #eee;
//   background-color: white;
//   ${props => props.index === 0 && 'border-top: 1px solid #eee;'};
//   padding-left: 5px;
//   &:hover {
//     background-color: #efefef;
//   }
// `
// const HeaderStatus = styled.div`
//   display: flex;
//   flex: 0 0 6em;
//   justify-content: center;
//   text-align: center;
// `

// const EndpointLabel = styled.div`
//   display: flex;
//   ${props =>
//     props.sandbox === 'Y'
//       ? 'background-color: #33cc33;'
//       : 'background-color: #0099ff;'};
//   border-radius: 20px;
//   font-weight: bold;
//   font-size: 0.9em;
//   flex: 0 0 6.7em;
//   justify-content: center;
//   align-items: center;
//   margin-left: 5px;
//   margin-right: 5px;
// `

const Url = styled.div`
  display: flex;
  flex: 0 0 25em;
  text-align: left;
`

const WSAccessEntry = props => {
  const {
    createRemoveTask,
    createSaveTask,
    retrieveData,
    // createUpdateActiveStatusTask,
    targetInfo,
  } = props

  const columns = [
    // {
    //   title: 'Active Endpoint',
    //   width: 80,
    //   dataIndex: 'activeStatus',
    //   key: 'activeStatus',
    //   align: 'center',
    //   render: (text, record) => (
    //     <HeaderStatus>
    //       <Radio
    //         checked={record.activeStatus}
    //         onClick={_ => setActiveStatus(record)}
    //         size="large"
    //       />
    //     </HeaderStatus>
    //   ),
    // },
    {
      title: 'Service Name',
      width: 140,
      dataIndex: 'serviceName',
      key: 'serviceName',
      align: 'center',
    },
    // {
    //   title: 'Endpoint Name',
    //   dataIndex: 'endpointName',
    //   key: 'endpointName',
    //   width: 120,
    //   align: 'center',
    //   render: (text, record) => (
    //     <EndpointLabel
    //       key={record.serviceName + 'sandbox'}
    //       sandbox={record.endpointName === 'SANDBOX' ? 'Y' : 'N'}
    //     >
    //       {record.endpointName}
    //     </EndpointLabel>
    //   ),
    // },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      width: 400,
      align: 'center',
      render: (text, record) => <Url>{record.url}</Url>,
    },
    {
      title: 'Username',
      dataIndex: 'userName',
      key: 'username',
      width: 200,
      align: 'center',
    },
    {
      title: 'Password',
      dataIndex: 'password',
      key: 'password',
      width: 200,
      align: 'center',
    },
    {
      title: 'Cert Email',
      dataIndex: 'certEmail',
      key: 'certEmail',
      width: 250,
      align: 'center',
      render: (text, record) => <Url>{record.certEmail}</Url>,
    },
    {
      title: 'Certificate',
      dataIndex: 'certificate',
      key: 'certificate',
      width: 100,
      align: 'center',
      render: (text, record) => (
        <span>
          <Icon
            style={{ marginRight: `5px`, cursor: `pointer` }}
            theme="twoTone"
            type={record.certificate === '1' ? 'file-text' : 'file'}
            onClick={_ =>
              record.certificate === '1' ? showModal(record) : null
            }
          />
          {record.certificate === '1' ? 'Certificate' : 'N/A'}
        </span>
      ),
    },
    // {
    //   title: 'Api User Id',
    //   dataIndex: 'apiUserId',
    //   key: 'apiUserId',
    //   width: 150,
    //   align: 'center',
    // },
    // {
    //   title: 'Api Signing Key',
    //   dataIndex: 'apiSigningKey',
    //   key: 'apiSigningKey',
    //   width: 400,
    //   align: 'center',
    //   render: (text, record) => <Url>{record.apiSigningKey}</Url>,
    // },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: 430,
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex' }}>
          <Button
            id="edit"
            key={record.serviceName + 'btn1'}
            css={{ marginRight: '5px', color: 'black' }}
            onClick={() => {
              setPromptMode('edit')
              setSelectedRecord(record)
            }}
          >
            Edit
          </Button>
          <WSAccessFileUpload
            displayText="Update Certificate"
            style={{ marginRight: '5px' }}
            serviceName={record.serviceName}
            endpointName={record.endpointName}
            retrieveData={retrieveData}
          />
          <FileDownload
            apiTarget="admin/web-service-access/download-certificate"
            downloadFileName="certificate.pfx"
            queryParams={{
              'service-name': record.serviceName,
              'endpoint-name': record.endpointName,
            }}
          >
            {({ downloadFile }) => (
              <Button
                key={record.serviceName + record.endpointName + 'download'}
                style={{ marginLeft: '5px' }}
                onClick={downloadFile}
                disabled={record.certificate !== '1'}
              >
                <Icon type="download" /> Download
              </Button>
            )}
          </FileDownload>
          <Popconfirm
            key={record.serviceName + 'pop'}
            placement="left"
            title={`Are you sure you want to delete the '${record.serviceName}' service data?`}
            onConfirm={_ => doRemove(record)}
            okText="Yes"
            cancelText="No"
          >
            <Button
              id="delete"
              key={record.serviceName + 'btn3'}
              css={{
                marginLeft: '5px',
                color: 'red',
              }}
            >
              Delete
            </Button>
          </Popconfirm>
        </div>
      ),
    },
  ]

  const { setError } = useContext(ErrorContext)
  const [promptMode, setPromptMode] = useState(null)
  const [selectedRecord, setSelectedRecord] = useState({})
  const initCertData = 'Loading........'

  const targetUrl = record =>
    `${
      targetInfo.baseUrl
    }/admin/web-service-access/view-certificate?${qs.stringify({
      'service-name': record.serviceName,
      'endpoint-name': record.endpointName,
    })}`

  const [certificateData, setCertificateData] = useState(initCertData)
  const [visible, setVisible] = useState(false)

  const showModal = record => {
    fetch(targetUrl(record), {
      method: 'GET',
      ...getCredentials(targetInfo),
      headers: getAuthorization(targetInfo),
    })
      .then(res => res.text())
      // .then(json => json.data)
      .then(function(data) {
        setCertificateData(data)
      })
      .catch(setError)
    setVisible(true)
  }

  const handleCancel = () => {
    setCertificateData(initCertData)
    setVisible(false)
  }

  const doRemove = record => {
    if (record.activeStatus) {
      const filterData = props.data.filter(
        d =>
          d.serviceName === record.serviceName &&
          d.endpointName !== record.endpointName
      )
      filterData.length > 0
        ? Modal.info({
            title: `Can't delete active service`,
            width: 800,
            content: (
              <div>
                <p>{`Please, make any other endpoint active for the '${record.serviceName}' before deleting active endpoint.`}</p>
              </div>
            ),
          })
        : createRemoveTask({
            serviceName: record.serviceName,
            endpointName: record.endpointName,
            activeStatus: record.activeStatus,
          })
    } else {
      createRemoveTask({
        serviceName: record.serviceName,
        endpointName: record.endpointName,
        activeStatus: record.activeStatus,
      })
    }
    // record.activeStatus
    //   ? message.error("Can't delete active Service !")
    //   : createRemoveTask({
    //       serviceName: record.serviceName,
    //       endpointName: record.endpointName,
    //       activeStatus: record.activeStatus,
    //     })
  }

  const saveTask = d => {
    setPromptMode(null)
    createSaveTask(d)
  }

  // const setActiveStatus = record =>
  //   record.activeStatus
  //     ? null
  //     : createUpdateActiveStatusTask({
  //         serviceName: record.serviceName,
  //         endpointName: record.endpointName,
  //         activeStatus: record.activeStatus,
  //       })

  return (
    <React.Fragment>
      <Table
        // style={{ height: height }}
        className="tableifw"
        key="wsaccesstable"
        rowKey={record => record.serviceName + '' + record.endpointName}
        size="middle"
        bordered
        columns={columns}
        dataSource={props.data}
        pagination={false}
        scroll={{ x: props.width - 50, y: props.height - 50 }}
        locale={{
          emptyText:
            'There are no data configured. Please use the "Create New WebService Access" button to add new data.',
        }}
      />

      {promptMode && (
        <WSAccessEditPrompt
          key={selectedRecord.serviceName + 'editPrompt'}
          mode={promptMode}
          {...props}
          {...selectedRecord}
          close={setPromptMode}
          getSaveTask={saveTask}
        />
      )}
      <Modal
        visible={visible}
        title="Certificate"
        width={1000}
        onCancel={handleCancel}
        footer={[
          <Button key="back" type="primary" onClick={handleCancel}>
            Close
          </Button>,
        ]}
      >
        <pre>{certificateData}</pre>
      </Modal>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(WSAccessEntry)
